import { computed, MaybeRefOrGetter, toValue } from "vue";

/**
 * @param {string} base Environment Domain of the embed (doh: Develpment, app: Production)
 * @param {string} slug Slug of the embed
 * @param {string} param Optional param of the embed (e.g. filter query string)
 * @returns {string} Embeded HTML String
 */
const embed = (
  base: string,
  slug: string,
  param?: string,
) => {
  const queryString = param ? `?${param}` : '';
  return `<style>.responsive23-${slug} { width: 100%; padding-top: 100%; } @media (max-width: 600px) { .responsive23-uo8ydGsUBzOcknIX-bar-horizontal-bar-chart { padding-top: 100%; } } @media (max-width: 360px) { .responsive23-${slug} { padding-top: 142.86%; } }</style>
<div id="container23-${slug}" class="responsive23-${slug}" style="position: relative;"><iframe title="Bar Chart" src="https://${base}.23degrees.io/embed/${slug}${queryString}" allow="fullscreen" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0"></iframe></div>
<script src="https://${base}.23degrees.io/services/public/embed-code/${slug}"></script>`;
};

// const base: "doh" | "app" = "doh";
// const paramSlug =
//   "9DcMsVjFAk83S537-bar-stacked-vertical-tourismus-in-oberfranken?filter=eyJhMCI6IlL2ZGVudGFsIn0";
// const [slug, param] = paramSlug.split("?");

// const theEmbed = embed(base, slug, param);

// console.log(theEmbed);

// export { theEmbed };

const regex23DegreesHostname = /^(doh|app)\.23degrees\.io$/

export function is23DegreesUrl(url: string) {
  // Valid Url hostnames: //doh.23degrees.io, //app.23degrees.io
  try {
    const _url = new URL(url);
    return regex23DegreesHostname.test(_url.hostname);
  } catch {
    return false
  }
}

export function extractSlugAndParamFromEmbed(url: string) {
  if (!url) return { base: "", slug: "", param: "" };
  let _url = undefined;
  // example url: "https://doh.23degrees.io/view/9DcMsVjFAk83S537-bar-stacked-vertical-tourismus-in-oberfranken?filter=eyJhMCI6IlL2ZGVudGFsIn0"
  // -> base = "doh", slug = "9DcMsVjFAk83S537-bar-stacked-vertical-tourismus-in-oberfranken", param = "eyJhMCI6IlL2ZGVudGFsIn0"
  try {
    _url = new URL(url);
  } catch {
    return { base: "", slug: "", param: "" };
  }

  return {
    base: _url.hostname?.match(regex23DegreesHostname)?.[1] || '',
    slug: _url.pathname?.split("/").slice(-1)[0] || '',
    param: _url.searchParams?.get("filter") ? `filter=${_url.searchParams.get("filter")}` : '',
  }
}

export function useEmbed23Deg(url: MaybeRefOrGetter<string>) {
  const options = computed(() => extractSlugAndParamFromEmbed(toValue(url)));
  const computedEmbed = computed(() => {
    if (!options.value.base || !options.value.slug) return "";
    return embed(options.value.base, options.value.slug, options.value.param || undefined)
  } );


  return {
    embed: computedEmbed
  }
}
